export default [
  {
    path: '/mobile/record/user-login-rec',
    name: 'mobile-record-user-login-rec',
    component: () => import('@/views/mobile/record/UserLoginRec.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '登录记录',
    },
  },
  {
    path: '/mobile/record/user-operation-log-rec',
    name: 'mobile-record-user-operation-log-rec',
    component: () => import('@/views/mobile/record/UserOperationLogRec.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '操作记录',
    },
  },
];
